import { logger } from '@gem/modules/logger';

import { pushNotificationsModel } from 'APP/model/model';
import { PushNotificationTokenType } from 'APP/model/pushNotifications/pushNotificationsModel.types';
import Entities from 'STORE';

export const unregisterNotifications = async (
  tokenType: PushNotificationTokenType
): Promise<void> => {
  try {
    await pushNotificationsModel.unregisterPushNotifications(
      tokenType,
      Entities.usersStore.myId || ''
    );

    logger
      .get('Push Notifications')
      .info(`${tokenType} - push notification service was unregistered on the server`);
  } catch (error) {
    logger
      .get('Push Notifications')
      .error(`${tokenType} - push notification service was not unregistered on the server`, error);
  }
};
